/**
 * Central launch configuration for People Watching.
 * Single source of truth for CTAs, brand voice, and CONFIRMED product facts.
 *
 * Rules:
 *   1. Never invent unconfirmed facts. Leave the value as `null` and the UI
 *      must hide it cleanly (no "TBC", "Coming soon", "Unknown", or 0).
 *   2. Flip `launch.isPreLaunch` to false only when ecommerce is confirmed live.
 */

export const CONFIG = {
  brand: {
    name: "People Watching",
    proposition: "The card game you play with the people around you.",
    coreMechanic: "Spot. Pass. Win.",
    supportingLine: "Everyone's Favourite Pastime.",
    domain: "playpeoplewatching.com",
    handle: "@playpeoplewatching",
  },

  launch: {
    // Flip to false ONLY when stock + checkout are confirmed live.
    isPreLaunch: true,
    ctaPreLaunch: "Join the Watch List",
    ctaPreLaunchShort: "Join Watch List",
    ctaPreLaunchAlt: "Be First to Play",
    ctaPostLaunch: "Get the Game",
  },

  // ── CONFIRMED PRODUCT FACTS ──────────────────────────────────────────────
  // Only populate values that are commercially locked. Leave unknowns null.
  product: {
    name: "People Watching",
    productType: "Card game",

    // Confirmed for launch:
    cardCount: 56,               // customer-facing: "56 cards"
    instructionCardCount: 2,     // included within the 56-card total
    playerCount: "3–8 players",
    age: "All ages",             // suitable for all ages — NOT an 18+ product

    // Intentionally unset — do NOT render placeholders in the UI:
    price: null,
    currency: "GBP",
    currencySymbol: "£",
    duration: null,              // no play-time claim until commercially confirmed

    // Detailed "What's in the box" contents list (safe, confirmed):
    contents: [
      "56-card People Watching deck",
      "2 instruction cards included within the deck",
      "Box packaging",
    ],
  },

  social: {
    instagram: "https://instagram.com/playpeoplewatching",
    tiktok:    "https://tiktok.com/@playpeoplewatching",
    youtube:   "https://youtube.com/@playpeoplewatching",
    facebook:  "https://facebook.com/playpeoplewatching",
  },

  contact: {
    email: "hello@playpeoplewatching.com",
  },
};

// ── CTA helpers ────────────────────────────────────────────────────────────
export const primaryCTA = () =>
  CONFIG.launch.isPreLaunch ? CONFIG.launch.ctaPreLaunch : CONFIG.launch.ctaPostLaunch;

export const primaryCTAShort = () =>
  CONFIG.launch.isPreLaunch ? CONFIG.launch.ctaPreLaunchShort : CONFIG.launch.ctaPostLaunch;

export const primaryCTATarget = () =>
  CONFIG.launch.isPreLaunch ? "#watch-list" : "/shop";
